import classNames from "classnames"
import { useRouter } from "next/router"
import React from "react"

export interface JsLinkProps {
  children: any
  className?: string
  link?: string
  style?: React.CSSProperties
}

const JsLink = ({ children, className, link, style }: JsLinkProps) => {
  const router = useRouter()
  const handleClick = () => {
    if (link) {
      router.push(link)
    }
  }
  return (
    <div
      className={classNames(
        {
          "cursor-pointer": !!link,
        },
        className
      )}
      onClick={handleClick}
      style={style}
    >
      {children}
    </div>
  )
}

export default JsLink
